import CommonStore from './Common'

class Store {
  constructor() {
    this.commonStore = new CommonStore(this)
  }
}

export default new Store()



// WEBPACK FOOTER //
// ./src/stores/index.js